import {queryOptions} from '@tanstack/react-query';
import axios from 'axios';
import {api} from '@/libs/baseApi.client';
import type {User} from '../types/user';

export const getUserOptions = () =>
  queryOptions({
    queryKey: ['user'],
    queryFn: async () => {
      try {
        // Токен передается автоматически через cookies (withCredentials: true)
        const response = await api.get<User>(`/users/profile`);
        return response.data;
      } catch (error) {
        // 401 - ожидаемая ситуация для неавторизованных пользователей, не логируем как ошибку
        if (axios.isAxiosError(error) && error.response?.status === 401) {
          return null;
        }
        // Логируем только реальные ошибки
        console.error('Failed to fetch user by id:', error);
        return null;
      }
    },
    // Добавляем настройки для лучшей работы с SSG
    staleTime: 5 * 60 * 1000, // 5 минут
    retry: false, // Не повторяем запрос при 401 (пользователь не авторизован)
  });
